// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ContractAdditionalLineResponse

export type ContractAdditionalLineApiResponse = {
	description: string;
	amount: number;
};

export type ContractAdditionalLine = {
	description: string;
	amount: number;
};

export function hydrateContractAdditionalLine(data: ContractAdditionalLineApiResponse): ContractAdditionalLine {
	return { ...data };
}